import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Apis
import { AppUnsubscribeApi } from '@core/api/app/unsubscribe.api';

/**
 * Service de désinscription publique — la clé provient de l'URL, aucun état à conserver.
 */
@Injectable({ providedIn: 'root' })
export class AppUnsubscribeService {
	constructor(private api: AppUnsubscribeApi) {}

	query(key: string): Observable<unknown> {
		return this.api.query(key);
	}

	action(action: string, key: string): Observable<unknown> {
		return this.api.action(action, key);
	}
}
